import styled, { css } from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 16px;
    margin-bottom: 16px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 40px;
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  padding-block: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid #e3e3e3;
  box-shadow: 4px 6px 60px 0px rgba(4, 86, 179, 0.1);
  clip-path: inset(-99px -99px 0 -99px); //to hide shadow-bottom
`;

export const InputRow = styled.div.withConfig({
  shouldForwardProp: (prop) => !['columnGap', 'rowGap'].includes(prop),
})`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${({ columnGap }) => columnGap}px;
  row-gap: ${({ rowGap }) => rowGap}px;

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TemplateLabelAndControls = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 48px;
  margin-bottom: 8px;

  > :first-child {
    align-self: flex-end;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 16px;
  }
`;

export const TemplateControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 48px;

  @media ${({ theme }) => theme.device.mobileL} {
    display: contents;
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.btnDisabledBg};
  //margin: 22px auto 10px;
`;

export const GroupsBox = styled.div`
  border-radius: 4px;
  background: ${(props) => props.theme.colors.bgBox};
  padding: 24px;

  @media ${({ theme }) => theme.device.mobileL} {
    border-radius: 0;
    margin-inline: -16px;
    padding: 24px 16px;
  }
`;

export const SelectedGroupsBox = styled.div`
  border-radius: 12px;
  margin-top: 32px;
  background: ${(props) => props.theme.colors.white};
  padding: 24px;

  @media ${({ theme }) => theme.device.mobileL} {
    padding: 24px 16px;
  }
`;

const gridTempCols = css`
  --padding-inline: 24px;

  display: grid;
  grid-template-columns: 60px 2fr 1fr 1fr;
  align-items: center;
  column-gap: 24px;
  padding-inline: var(--padding-inline);

  @media ${({ theme }) => theme.device.mobileL} {
    --padding-inline: 0;
  }
`;

export const Legend = styled.div`
  ${gridTempCols}
  padding: 0 24px;
  margin-bottom: 16px;

  > :first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }
`;

export const GroupCard = styled.div`
  ${gridTempCols}
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  background: ${(props) => props.theme.colors.white};
  padding-block: 24px;
  border-radius: 4px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    grid-template-columns: 100px 1fr;
    align-items: start;
    row-gap: 16px;
    box-shadow: none;
    border-radius: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};

    label {
      color: ${(props) => props.theme.colors.primaryDarkGray700};
    }

    > *:nth-child(even) {
      text-align: right;
    }
  }

  .checkbox-wrapper {
    position: relative;
    top: 10px;
  }

  button {
    margin-left: auto;

    @media ${({ theme }) => theme.device.mobileL} {
      margin-top: 8px;
    }
  }
`;
